const calculateAge = date => {
  const birthDate = new Date(date);
  const today = new Date();
  const years = today.getFullYear() - birthDate.getFullYear();

  if (
    today.getMonth() < birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
  ) {
    return years - 1;
  }
  return years;
};

const checkAge = (user, age, userAgeWarning) => {
  if (user.student && age < userAgeWarning.student) {
    return "Devi avere almeno 14 anni, controlla la tua data di nascita.";
  }
  if (!user.student && age < userAgeWarning.default) {
    return "Devi essere maggiorenne, controlla la tua data di nascita.";
  }
  return "";
};

export default {
  calculateAge,
  checkAge,
};
